export default "__VITE_ASSET__IUov3jUW__"